/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../constants';
import AppLoader from '../../common-components/AppLoader';
import { Box } from '@mui/material';

interface GuestGuardProps {
  children: React.ReactNode;
}

export default function GuestGuard({ children }: GuestGuardProps): React.ReactElement {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const pushToPortal = useCallback(() => {
    setIsLoading(false);
    const accessToken = localStorage.getItem(`token-${process.env.REACT_APP_PUBLIC_URL}`);
    if (accessToken) {
      navigate(ROUTE_PATHS.PORTAL);
    }
  }, []);
  useEffect(() => {
    const accessToken = localStorage.getItem(`token-${process.env.REACT_APP_PUBLIC_URL}`);
    if (!accessToken) {
      setIsLoading(true);
      setTimeout(() => {
        pushToPortal();
      }, 3000);
    } else {
      pushToPortal();
    }
  }, []);
  return (
    <>
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <AppLoader />
        </Box>
      ) : (
        <>{children}</>
      )}
    </>
  );
}
